import React from "react";

interface CheckboxUncheckedProps {
  selected?: boolean;
  theme: any;
}

export const CheckboxUnchecked = (props:CheckboxUncheckedProps) => {
  const {selected, theme} = props;
  const themeValue = localStorage.getItem("theme") || "dark";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1"
        width="23"
        height="23"
        rx="1.5"
        fill= {theme.name === "dark-theme" ? "white" : "black"}
        fillOpacity="0.15"
        // stroke={themeValue==="dark"? (selected? "black" : "white") : (selected? "white" : "black")}
        stroke={(themeValue === "dark" && selected) || (themeValue !=="dark" && !selected) ? "black" : "white"}
      />
    </svg>
  );
};

export default CheckboxUnchecked;
